export const workerSalaryType = {
    // 고정급
    FIXED_PAY: 'FIXED_PAY',
    // 성과급
    PERFORMANCE_PAY: 'PERFORMANCE_PAY',
};
